// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * GUID in canonical string form.
 */
export class Guid implements flatbuffers.IUnpackableObject<GuidT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Guid {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsGuid(bb: flatbuffers.ByteBuffer, obj?: Guid): Guid {
    return (obj || new Guid()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsGuid(bb: flatbuffers.ByteBuffer, obj?: Guid): Guid {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Guid()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): string;
  value(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  value(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startGuid(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0);
  }

  static endGuid(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // value
    return offset;
  }

  static createGuid(
    builder: flatbuffers.Builder,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Guid.startGuid(builder);
    Guid.addValue(builder, valueOffset);
    return Guid.endGuid(builder);
  }

  unpack(): GuidT {
    return new GuidT(this.value());
  }

  unpackTo(_o: GuidT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): GuidT {
    const t = new GuidT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class GuidT implements flatbuffers.IGeneratedObject {
  constructor(public value: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const value = this.value !== null ? builder.createString(this.value!) : 0;

    return Guid.createGuid(builder, value);
  }

  clone(): GuidT {
    const obj = new GuidT();
    obj.value = this.value;
    return obj;
  }

  equals(other: GuidT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyGuid(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "value");
  } finally {
    verifier.popDepth();
  }
}
